import { createElement as _createElement } from "react";
import { TS_BaseInput } from './TS_BaseInput.js';
import './TS_TextArea.scss';
import { _className } from '../../utils/tools.js';
import { getComputedStyleProperty } from '../utils.js';
export class TS_TextArea extends TS_BaseInput {
    componentDidMount() {
        if (this.state.value && this.props.resizeWithText)
            this.resizeWithText();
    }
    onKeyDown = (ev) => {
        if (!(ev.shiftKey || ev.altKey)) {
            if (ev.ctrlKey || ev.metaKey) {
                if (ev.key === 'Enter') {
                    ev.persist();
                    const value = ev.currentTarget.value;
                    //@ts-ignore - despite what typescript says, ev.target does have a blur function.
                    ev.target.blur();
                    if (this.props.onAccept) {
                        this.props.onAccept(value, ev);
                        ev.stopPropagation();
                    }
                }
                return;
            }
            if (ev.key === 'Escape' && this.props.onCancel) {
                this.props.onCancel();
                ev.stopPropagation();
            }
        }
        this.props.onKeyDown?.(ev);
    };
    resizeWithText = () => {
        const el = this.ref;
        if (!el)
            return;
        const currentHeight = el.offsetHeight;
        if (el.scrollHeight > currentHeight) { //Can increase height
            const newHeight = el.scrollHeight + 5;
            el.style.height = `${newHeight}px`;
        }
        else { //Check if height needs to be decreased
            const borderWidthTop = Number(getComputedStyleProperty(el, 'border-top-width')?.replace('px', ''));
            const borderWidthBottom = Number(getComputedStyleProperty(el, 'border-bottom-width')?.replace('px', ''));
            const borderWidth = borderWidthTop + borderWidthBottom;
            el.style.height = '1px';
            const scrollHeight = el.scrollHeight;
            const heightDiff = currentHeight - scrollHeight;
            const newHeight = heightDiff <= borderWidth + 1 ? currentHeight : scrollHeight + borderWidth + 1;
            el.style.height = `${newHeight}px`;
        }
    };
    _changeValue = (e) => {
        this.changeValue(e);
        if (this.props.resizeWithText)
            this.resizeWithText();
    };
    render() {
        const { onAccept, focus, enable, resizeWithText, ...props } = this.props;
        return _createElement("textarea", { ...props, ref: input => {
                if (this.ref || !input)
                    return;
                this.ref = input;
                this.props.focus && this.ref.focus();
            }, onBlur: (event) => {
                this.ref = undefined;
                const value = event.target.value;
                this.setState({ value });
                this.props.onBlur?.(value, event);
            }, disabled: this.props.disabled, name: this.props.name || this.props.id, key: this.props.id, id: this.props.id, className: _className('ts-textarea', this.props.className), style: this.props.style, value: this.state.value, placeholder: this.props.placeholder, onChange: this._changeValue, onKeyDown: this.props.onKeyDown || this.onKeyDown, autoComplete: this.props.autoComplete ? 'on' : 'off', spellCheck: this.props.spellCheck });
    }
}
//# sourceMappingURL=TS_TextArea.js.map